import { styled } from "sharedUI/styles";

export const PreviewAsModalStyle = styled.div`
    position: relative;
    width: 300px;
    left: 0px;
    top: calc(100% + 1px);
    background: ${p => p.theme.bgColorLight};
    padding: 12px;
    box-sizing: border-box;
    box-shadow: ${p => p.theme.shadowDark2};
    border-radius: 9px;
    color: ${p => p.theme.fgColorDark};
    font-size: 13px;

    .footer-container {
        margin-top: 8px;
        padding-top: 8px;
        border-top: 1px solid ${p => p.theme.borderColor};
    }

    .show-hide-wrapper {
        display: flex;
        align-items: center;

        input {
            appearance: checkbox;
            width: 16px;
            height: 16px;
            border: 2px solid;
            border-radius: 4px;
            border-color: ${p => p.theme.bgColorMedium};
            margin-right: 10px;
        }
    }

    .user-profiles-area {
        .user-profile-list {
            max-height: 385px;
            overflow-y: auto;
            margin: 0 -12px;
        }

        input {
            width: 100%;
            height: 32px;
            border-radius: 8px;
            background: ${p => p.theme.formControlBg};
            color: ${p => p.theme.fgColorDark};
            padding: 0 10px;
            margin-bottom: 10px;

            ::placeholder {
                color: ${p => p.theme.fgColorLight};
            }

            &:hover,
            &:focus {
                background: ${p => p.theme.formControlBgHover};
            }
        }

        li {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 13px;
            padding: 6px;
            margin: 0 8px;
            border-radius: 8px;

            cursor: pointer;

            &:hover,
            &:focus {
                background-color: ${p => p.theme.bgColorAlt};
            }

            & + li {
                margin-top: 1px;
            }

            .user-image {
                width: 20px;
                height: 20px;
                object-fit: cover;
                border-radius: 100px;
                margin-right: 4px;
                background-color: ${p => p.theme.borderColor};
            }

            .profile-roles {
                color: ${p => p.theme.fgColorMedium};
                line-height: 15px;
                font-variant: all-small-caps;
            }

            > div {
                display: flex;
                align-items: center;
            }

            .selected-icon {
                display: none;
                line-height: 0;
                position: absolute;
                top: 50%;
                right: 10px;
                transform: translateY(-50%);
            }
        }

        li.selected,
        li.selected:hover,
        li.selected:focus {
            background-color: ${p => p.theme.n200A};

            .selected-icon {
                display: block;
            }
        }
    }
`;
